import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { Ordered as EdenOrdered, Unordered as EdenUnordered } from "@churchofjesuschrist/eden-list";
export { Item } from "@churchofjesuschrist/eden-list";
const listSpacing = `
  margin-top: ${spacing16};
  margin-bottom: ${spacing16};
`;
const SpacedOrdered = styled(EdenOrdered).withConfig({
  componentId: "sc-1j35ow6-0"
})(["", ""], listSpacing);
const SpacedUnordered = styled(EdenUnordered).withConfig({
  componentId: "sc-1j35ow6-1"
})(["", ""], listSpacing);
export const Ordered = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(SpacedOrdered, props, children);
};
Ordered.propTypes = {
  /* List content */
  children: PropTypes.node.isRequired
};
export const Unordered = _ref2 => {
  let {
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(SpacedUnordered, props, children);
};
Unordered.propTypes = {
  /* List content */
  children: PropTypes.node.isRequired
};